
import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { NavLink as RRNavLink, Link, withRouter } from 'react-router-dom';
import _ from 'lodash';

import { observer } from 'mobx-react';
require('dotenv');


class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        const path = this.props.location.pathname;

        this.toggleNavbar = this.toggleNavbar.bind(this);

        this.state = {
            collapsed: true,
        };

        this.changeView = this.changeView.bind(this);
    }

    async changeView(){
        await this.props.store.changeView()
    }

    //Checks if current path is a "new" path
    getNewPathClass = () => {
        const newPaths = ["/staff/Holiday", "/staff/Employer", "/staff/Supervisor", "/staff/Student", "/staff/Account", "/staff/Timesheet"]

        return newPaths.includes(this.props.location.pathname)
            ? " activeNav"
            : "";
    };

    getReportPathClass = () => {
        const reportPaths = ["/staff/certifyTimesheets","/staff/KronosReport","/staff/allAccountsSummary", "/staff/timesheetByPayWeek", "/staff/timesheetBySubmissionDate", "/staff/timesheetByCertificationDate", "/staff/timesheetByDateRange", "/staff/allActiveStudents", "/staff/timesheetByStudent", "/staff/StudentMigration"]

        return reportPaths.includes(this.props.location.pathname)
            ? " activeNav"
            : "";
    };

    getMessagingPathClass = () => {
        const reportPaths = ["/staff/messageStudent", "/staff/selectMessage"]

        return reportPaths.includes(this.props.location.pathname)
            ? " activeNav"
            : "";
    };

    getUpdatePathClass = () => {
        return (this.props.location.pathname !== "/"
            && this.props.location.pathname !== "/staff/viewAsStudent"
            && this.getReportPathClass() === ""
            && this.getNewPathClass() === ""
            && this.getMessagingPathClass() === "") 
            ? " activeNav"
            : ""
    }


    //When location is updated, update state  
    componentDidUpdate(prevProps) {
        
        const {
            location
        } = this.props;

        const prevLocation = prevProps.location.pathname;

        if (location.pathname !== prevLocation) {
            // use `course` to reload the correct course content
            this.setState({
                path: location.pathname
            })
        }
     }



    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }


    render() {
        return (
            <header id="siteHeader">
                <Container className="d-flex flex-row justify-content-between align-items-center" style={{ marginTop: "36px" }}>
                    <Link to="/"><img src="imgs/logo.png" alt="Temple Law Logo" className="" style={{ maxWidth: "243px"  }} /></Link>
                    <div>
                        <p style={{ color: "#A41E35", fontSize: "30px", marginBottom: "0" }}>Summer Work Study</p>
                        <p style={{ color: "#1D1D1D", textAlign:"right", fontSize:"20px"}}><b>Student Work Log</b></p>
                    </div>
                </Container>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow pb-0">
                    <Container>
                        {/*<NavbarBrand tag={Link} to="/">Summer Work Study</NavbarBrand>*/}
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />

                        <Collapse className="d-sm-inline-flex flex-sm-row" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav w-100">

                                <NavItem>
                                    <NavLink tag={RRNavLink} className="text-dark pl-0" exact to="/" activeClassName="activeNav">Dashboard</NavLink>
                                </NavItem>

                                <li className={this.props.store.user.isAdmin ? "nav-item dropdown" : "nav-item dropdown d-none"}>
                                    <a tag={RRNavLink} className={"nav-link text-dark dropdown-toggle" + this.getNewPathClass()} href="#" id="NewItemDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        New
                                    </a>
                                    <div className="dropdown-menu" aria-labelledby="NewItemDropdown">
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" exact to="/staff/Employer" activeClassName="activeNav">Employer</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" exact to="/staff/Supervisor" activeClassName="activeNav">Supervisor</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" exact to="/staff/Student" activeClassName="activeNav">Student</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" exact to="/staff/Account" activeClassName="activeNav">Account</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item d-none text-dark" to="/staff/Timesheet" activeClassName="activeNav">Timesheet</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" exact to="/staff/Holiday" activeClassName="activeNav">Date Notice</NavLink>
                                    </div>
                                </li>

                                <li className={this.props.store.user.isAdmin ? "nav-item dropdown" : "nav-item dropdown d-none"}>
                                    <a className={"nav-link text-dark dropdown-toggle" + this.getUpdatePathClass()} href="#" id="UpdateItemDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Update
                                    </a>
                                    <div className="dropdown-menu" aria-labelledby="UpdateItemDropdown">
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/SelectEmployer" activeClassName="activeNav">Employer</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/SelectSupervisor" activeClassName="activeNav">Supervisor</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/SelectStudent" activeClassName="activeNav">Student</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/SelectAccount" activeClassName="activeNav">Account Details</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/SelectTimesheet" activeClassName="activeNav">Timesheet</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/SelectHoliday" activeClassName="activeNav">Date Notice</NavLink>

                                    </div>
                                </li>

                                <li className={this.props.store.user.isAdmin ? "nav-item dropdown" : "nav-item dropdown d-none"}>
                                    <a className={"nav-link text-dark dropdown-toggle" + this.getReportPathClass()} href="#" id="ReportsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Reports
                                     </a>
                                    <div className="dropdown-menu" aria-labelledby="ReportsDropdown">
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/KronosReport" activeClassName="activeNav">Kronos Report</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/certifyTimesheets" activeClassName="activeNav">Certify Timesheets</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/StudentMigration" activeClassName="activeNav">Student Migration</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/timesheetByStudent" activeClassName="activeNav">All Timesheets By Student</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/allAccountsSummary" activeClassName="activeNav">All Accounts Summary</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/employerSummary" activeClassName="activeNav">Employer Summary</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/timesheetByPayWeek" activeClassName="activeNav">Timesheets By Pay Week</NavLink>
                                        <NavLink tag={RRNavLink} className="dropdown-item text-dark" to="/staff/timesheetByDateRange" activeClassName="activeNav">Timesheets By Date Range</NavLink>
                                    </div>
                                </li>

                                {this.props.store.user && this.props.store.user.isAdmin && (
                                    <li className={this.props.store.user.isAdmin ? "nav-item dropdown" : "nav-item dropdown d-none"}>
                                        <a className={"nav-link text-dark dropdown-toggle" + this.getMessagingPathClass()} href="#" id="MessagingDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            Messaging
                                        </a>
                                        <div className="dropdown-menu" aria-labelledby="MessagingDropdown">
                                            <NavLink tag={RRNavLink} className="text-dark dropdown-item" to="/staff/messageStudent" activeClassName="activeNav">Message Student</NavLink>
                                            <NavLink tag={RRNavLink} className="text-dark dropdown-item" to="/staff/selectMessage" activeClassName="activeNav">View Messages</NavLink>
                                        </div>
                                    </li>
                                )}


                                {this.props.store.user.isUser && !this.props.store.user.isAdmin && (
                                    <NavItem>
                                        <NavLink tag={RRNavLink} className="text-dark nav-link" to="/student/messages" activeClassName="activeNav">Messages</NavLink>
                                    </NavItem>
                                )}

                                {this.props.store.user && this.props.store.user.isAdmin && (
                                    <NavItem className="ml-auto">
                                        <NavLink tag={RRNavLink} className="text-dark nav-link" to="/staff/viewAsStudent" activeClassName="activeNav">View as Student</NavLink>
                                    </NavItem>
                                )}
                                {this.props.store.user && (this.props.store.prevUser && this.props.store.prevUser.isAdmin) && (
                                    <NavItem className="ml-auto">
                                        <NavLink tag={RRNavLink} onClick={this.changeView} className="text-dark nav-link" to="/">View as Admin</NavLink>
                                    </NavItem>
                                )}
                                { !_.isEmpty(this.props.store.user) && (
                                    <NavItem className={(this.props.store.user.isAdmin || Object.keys(this.props.store.prevUser).length !== 0 ) ? "" : "ml-auto"}>
                                        <a className="text-dark nav-link" onClick={this.props.store.signOut}>Sign Out</a>
                                    </NavItem>
                                )}
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        )
    }

}


NavMenu = withRouter(observer(NavMenu));

export { NavMenu }